import { call, select } from "redux-saga/effects";
import { TempIdsMap } from "../../../../api/api-slice";
import { selectComponentTempIdsMap } from "../../../../api/selectors";
import ComponentsService from "../../../../../services/ComponentsService";
import { ComponentType, IUpdateComponentCommand } from "@growth-machine-llc/stridist-api-client";
import { selectPresentCurriculumId } from "../../../selectors/curriculum";

export function* updateComponentIconWorker(payload: {
  componentId: number;
  iconName: string;
}) {
  const { componentId, iconName } = payload;

  const map: TempIdsMap = yield select(selectComponentTempIdsMap);
  const checkedComponentId = map?.[componentId] || componentId;

  const command: IUpdateComponentCommand = {
    id: checkedComponentId,
    iconName
  };

  try {
    yield call(ComponentsService.update, command);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export function* updateComponentDefaultIconWorker(payload: {
  componentType: ComponentType;
  iconName: string;
}) {
  const { componentType, iconName } = payload;

  const programId: number = yield select(selectPresentCurriculumId);

  try {
    yield call(ComponentsService.updateDefaultIcon, programId, componentType, iconName);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
